/*
 * @Author: Ashley.Liu
 * @Date: 2022-05-09 13:14:02
 * @LastEditTime: 2022-07-08 20:30:59
 * @Description: desc
 */
import { getTopicDict, getUserDict } from '@/api'
import { getTagDict } from '@/api/tags'
import { listTooltip } from '@/api/tip'
import Vue from 'vue'
import DictError from '@/components/dictError'
export default {
  namespaced: true,
  state: {
    tooltipsDict: {},
    topicsDict: [],
    usersDict: [],
    tagsDict: []
  },
  mutations: {
    setTooltips (state, payload) {
      state.tooltipsDict = payload
    },
    setTopics (state, payload) {
      state.topicsDict = payload
    },
    setUsers (state, payload) {
      state.usersDict = payload
    },
    setTags (state, payload) {
      state.tagsDict = payload
    }
  },
  actions: {
    async getTooltipsDict (context, params) {
      try {
        const resp = await listTooltip()
        if (resp) {
          context.commit('setTooltips', resp || {})
        }
      } catch (error) {
        DictError(() => { context.dispatch('getTooltipsDict') }, error)
      } finally {
        Vue.prototype.$eventBus.$emit('tooltips-loaded')
      }
    },
    async getTopicsDict (context, params) {
      try {
        const resp = await getTopicDict()
        if (resp && resp.length) {
          context.commit('setTopics', resp || [])
        }
      } catch (error) {
        DictError(() => { context.dispatch('getTopicsDict') }, error)
      } finally {
        Vue.prototype.$eventBus.$emit('topics-loaded')
      }
    },
    async getUsersDict (context, params) {
      try {
        const resp = await getUserDict()
        if (resp && resp.length) {
          context.commit('setUsers', resp || [])
        }
      } catch (error) {
        DictError(() => { context.dispatch('getUsersDict') }, error)
      } finally {
        Vue.prototype.$eventBus.$emit('users-loaded')
      }
    },
    async getTagsDict (context, params) {
      try {
        const resp = await getTagDict()
        if (resp && resp.length) {
          context.commit('setTags', resp || [])
        }
      } catch (error) {
        DictError(() => {
          context.dispatch('getTagsDict')
        }, error)
      } finally {
        Vue.prototype.$eventBus.$emit('tags-loaded')
      }
    }
  }
}
